import script from "./LicenseplateCorrection.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseplateCorrection.vue?vue&type=script&setup=true&lang=js"

import "./LicenseplateCorrection.vue?vue&type=style&index=0&id=944f8c26&scoped=true&lang=css"

import exportComponent from "F:\\2024-岗亭\\jxwx-carpark-duty\\jxwx-carpark-duty\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-944f8c26"]])

export default __exports__